import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import StatusChip from '../../customTableComponent/statusChip';
// import EmbryoFileUpload from './embryoFileUpload';
import EmbryoImageLightbox from '../../../pages/Embryology/Embryo_Culture/EmbryoImageLightbox';

  
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const EmbryoDetailsTable = ({ embryoDetails }: { embryoDetails: any[] }) => {
  
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [file, setFile] = useState<File | null>(null); 
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [imagePathUrl, setImagePathUrl] = useState<string | null>(null);
  const [lightboxData, setLightboxData] = useState<{ imageUrl: string | null; embryo_no: number | null, label:string | null }>({ imageUrl: null, embryo_no: null, label:null });
  const { t } = useTranslation('general');

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow
            sx={{
              height: '2rem',
              background: 'rgba(250, 250, 250, 1)',
              border: 'none',
              '& .MuiTableCell-root': {
                padding: '0.6rem 0.6rem',
              },
            }}
          >
            {[t('embryoNo'), t('grade'), t('cellStage'), t('status'), t('image')].map((title, index) => (
              <TableCell
                key={index}
                sx={{
                  fontFamily: 'Nunito, sans-serif',
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  lineHeight: '1.45',
                  textAlign: 'left',
                  color: 'rgba(35, 35, 35, 1)',
                }}
              >
                {title}
              </TableCell>
            ))} 
          </TableRow>
        </TableHead>
        <TableBody>
          {embryoDetails.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5} align="center">
                <Typography variant="h6" color="textSecondary">
                  {t('noDataFound')}
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            embryoDetails.map((embryo, index) => (
              <TableRow key={index}>
                <TableCell>{embryo.embryo_number}</TableCell>
                <TableCell>{embryo.grade}</TableCell>
                <TableCell>{embryo.number_of_cells}</TableCell>
                <TableCell>
                  <StatusChip value='Fresh' />  
                </TableCell>

                <TableCell 
                  onClick={() => setLightboxData({ 
                    imageUrl: embryo.files[0]?.file, 
                    embryo_no: embryo.embryo_number, 
                    label: `E: ${embryo.embryo_number} D: ` 
                  })}
                  sx={{ cursor: 'pointer' }}
                >
                  <img 
                    src={embryo.files[0]?.file} 
                    alt={`Embryo ${embryo.embryo_number}`} 
                    style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 4 }} 
                  />
                </TableCell>

                {/* temp commented due image api changed */}
                {/* <TableCell>
                  {embryo.transfer_files_url ? (
                    <>
                      <EmbryoFileUpload id={embryo.id} onFileUpload={setFile} imagePathUrl={embryo.transfer_files_url} />
                    </>
                  ) : (
                    <EmbryoFileUpload id={embryo.id} onFileUpload={setFile}  imagePathUrl={imagePathUrl} />
                  )}
                </TableCell> */}
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
      
      {lightboxData.imageUrl && (
        <EmbryoImageLightbox 
          imageUrl={lightboxData.imageUrl} 
          embryoNumber={lightboxData.embryo_no} 
          label= {lightboxData.label}
          onClose={() => setLightboxData({ imageUrl: null, embryo_no: null, label:null })} 
        />
      )}

    </TableContainer>
    
  );
};

export default EmbryoDetailsTable;
